
import React from 'react';
import LMadAds from 'views/LMadAds';

const HelpCenterPage = () => {
  return <LMadAds />;
};

export default HelpCenterPage;
